import { io } from "socket.io-client";
import Cookies from "js-cookie";

const URL = process.env.REACT_APP_SOCKET_DOMAIN;

export const socket = io(URL, {
  query: {
    language: "th", // 'th
    access_token: Cookies?.get("jwt_token_control") ?? "",
    // Opt-in tier filter (CORNTROL-662, docs/2026-08-15-corntrol-662-frontend-
    // handoff.md): with this flag the socket feed omits starter-tier devices,
    // which monitoring must not show. Omitting it falls back to the unfiltered
    // feed the mobile app gets — so this line is the half of the fix that
    // actually turns it on. REST list endpoints are NOT covered by this flag;
    // whether they still return starter devices is checked separately.
    clientType: "monitoring",
  },
});
